<template>
  <div class="build-details">
    <ba-header activeModule="Web Builds"></ba-header>
    <div v-loading="loading" class="build-details__root main-content">
      <div class="u-pt4"></div>
      <div class="u-pt4"></div>
      <h2 class="u-text--center">Build {{ humanBuildId }} Details</h2>
      <div class="controls-container u-text--center">
        <el-button icon="el-icon-refresh" @click="invalidateBuildStatus()">Invalidate Status</el-button>
      </div>
      <div class="u-text--center u-mt3">
        <ba-status-label element-loading-background="rgba(0, 0, 0, 0.1)" v-if="build"
                         :build="build"></ba-status-label>
      </div>


      <div v-if="loading">Loading...</div>
      <div v-if="!loading && build && build.status=='SUCCEEDED'">

      </div>
      <div class="u-text--right">
        <el-checkbox v-model="showBuildTechnicalDetails">Show Build Technical Details</el-checkbox>
      </div>
      <el-collapse-transition>
        <div v-show="showBuildTechnicalDetails">

            <pre class="build__pre u-px4">
            <div>Build status : {{build.status}}</div>
            <div>aws_build_id : {{build.aws_build_id}}</div>
            <div>internal_id : {{build.internal_id}}</div>
            <div>queued_at: {{build.queued_at | moment('YYYY-MM-DD HH:mm')}}</div>
            <div>queued_at (UTC): {{build.queued_at}} (UTC)</div>
            <div>commit_id: {{build.commit_id ? build.commit_id : '[master]'}}</div>
            <div>queued_by: {{build.queued_by}}</div>

            </pre>
        </div>

      </el-collapse-transition>
      <div class="row" v-if="!loading && build">
          <div class="col-12 u-text--center u-mt5" v-if="!loading && build && build.status=='SUCCEEDED'">
            <el-button @click="publishBuildKubernetes"  v-if="!loading && build && build.status=='SUCCEEDED'" :disabled="kuberenetesPublishInProgress" type="success"
                       element-loading-background="rgba(0, 0, 0, 0.1)">
              <icon name="cloud-upload"></icon>
              <span class="u-ml1">Publish On Kubernetes!</span>
            </el-button>

        </div>
        <div class="row u-text--center u-mb5">
          <div class="col-12 u-mt4">
            <el-button @click="copyToClipboard(kubernetesUrl)">
              <icon name="clipboard"></icon>
              Copy Url
            </el-button>
          </div>
          <div class="col-12 u-mt4">
            <a :href="kubernetesUrl" target="_blank"
               class="desktop__preview-link u-m4 u-text--center">
              {{kubernetesUrl}}
            </a>


          </div>

        </div>
        <h4 class="u-text--center u-text--sm u-text--light u-mt5 u-pb5" title="Build comment">{{build.comment}}</h4>
        <div class="u-ml5">
          <ba-build-log :mode="'desktop'" :build-id="buildId"/>
        </div>
        <ba-desktop-build-smoke-tests :build-id="buildId" :commit-id="build.commit_id"/>
        <ba-desktop-build-deployments v-if="!kuberenetesPublishInProgress" :build-id="buildId"></ba-desktop-build-deployments>
      </div>
    </div>
  </div>

</template>

<script>
  import axios from 'axios'
  import config from '@/config'
  import DesktopBuildDeployments from '@/modules/builds/desktop-build-depoyments.component'
  import BaBuildLog from './build-log.component'
  import BaDesktopBuildSmokeTests from '@/modules/builds/desktop-build-smoke-tests.component'

  export default {
    components: {
      BaDesktopBuildSmokeTests,
      BaBuildLog,
      'ba-desktop-build-deployments': DesktopBuildDeployments,
    },
    data () {
      let buildId = this.$route.params.buildId
      let companyId = this.$route.params.companyId
      return {
        dialogVisible: false,
        loading: true,
        kuberenetesPublishInProgress: false,
        buildId,
        showBuildTechnicalDetails: false,
        build: {},
        loadBuildTimerRef: null,
        companyId,
      }
    },
    computed: {
      kubernetesUrl () {
        return 'http://' + this.build.kubernetes_url
      },
      humanBuildId () {
        return this.build ? this.build.version + '.' + this.build.build_number : 'UNDEFINED'
      }
    },
    methods: {
      invalidateBuildStatus () {
        this.loading = true
        axios.patch(config.url + '/desktop-build/' + this.buildId + '/')
          .then(response => {
            this.loading = false
            this.build = response.data
          })
      },
      publishBuildKubernetes () {
        this.kuberenetesPublishInProgress = true
        axios.post(config.url + '/desktop-build/' + this.buildId + '/publish-on-kubernetes/', {})
          .then(_ => {
            console.log('_', _.data)
            this.$notify({
              message: 'Site for ' + this.build.company + ' will be deployed on k8 shortly.',
              type: 'success'
            })
          })
          .catch(_ => {
            this.$notify({
              title: 'Error while publishing site live',
              message: _.data,
              type: 'error',
              duration: 0
            })
          })
          .finally(() => {
            this.kuberenetesPublishInProgress = false
            this.loading = false
          })
      },
      loadBuild () {
        if (this.build.status && ['queued', 'IN_PROGRESS'].indexOf(this.build.status) === -1) {
          this.loading = false
          return
        }
        this.loading = true

        axios.get(config.url + '/desktop-build/' + this.buildId + '/')
          .then(response => {
            if (!this.loading) {
              this.loading = false
            }
            this.loading = false
            this.build = response.data
            if (['queued', 'IN_PROGRESS'].indexOf(this.build.status) !== -1) {
              this.loading = false
              this.initBuildStatus = this.build.status
              this.loadBuildTimerRef = setTimeout(this.loadBuild, 15000)
            } else {
              this.loading = false
            }
          })
          .finally(() => {
            this.loading = false
          })
      },
      copyToClipboard (valueToCopy) {
        const el = document.createElement('textarea')
        el.value = valueToCopy
        document.body.appendChild(el)
        el.select()
        document.execCommand('copy')
        document.body.removeChild(el)
      }
    },
    beforeMount () {
      this.loading = true
      this.initBuildStatus = null
      this.loadBuild()
    },
    beforeDestroy () {
      clearTimeout(this.loadBuildTimerRef)
    }
  }
</script>
<style>

  .build__pre {
    background-color: #eeeeee;

  }

  .desktop__preview-link {
    text-align: center;
    display: block;
    text-decoration: underline;
  }

</style>
